import React, { useRef } from 'react';

//@ts-ignore
import ProgressBar from 'react-animated-progress-bar';


import { Container } from './styles';

interface ICardDiscipline3DProps {
  to: string;
  cardBackground: string;
  progress: number;
  icon: string;
  moduleName: string;
  alt: string;
}

const CardDiscipline3D: React.FC<ICardDiscipline3DProps> = ({
  to,
  alt,
  progress,
  icon,
  moduleName,
}) => {
  const ref = useRef(null);
  const scrollRef = document.querySelector('#main-scroll');

  return (
    <>
      <Container to={to} progress={progress}>
        <div
          ref={ref}
          style={{ padding: '1rem', zIndex: 999 }}
        >
          <header>
            <img src={icon} alt={moduleName} /> 
          </header>
          <footer>
            <div>
              <h5>{moduleName}</h5>
              <p>{progress.toFixed(0)}%</p>
            </div>
            <footer>
              <ProgressBar
                width="100%"
                height="12px"
                rect
                scrollArea={scrollRef}
                percentage={progress.toFixed(0)}
                rectPadding="2px"
                trackPathColor="#ffffff20"
                bgColor="#6befb0"
                trackBorderColor="transparent"
              />
            </footer>
          </footer>
        </div>
      </Container>
    </>
  );
};

export default CardDiscipline3D;
